export default {
  INITIATED: "INITIATED",
  TRANSIT: "TRANSIT",
  DELIVERED: "DELIVERED",
  INSPECTED: "INSPECTED",
}
